import React from 'react';
import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';

// Was previously white text on the default (light) background - completely
// invisible. Rebuilt as a proper not-found state.
const Error = () => {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="mx-auto h-16 w-16 rounded-full bg-slate-100 flex items-center justify-center mb-5">
          <FileQuestion className="h-8 w-8 text-slate-400" />
        </div>
        <p className="text-sm font-semibold text-blue-700 tracking-wide">404</p>
        <h1 className="text-2xl font-semibold text-slate-900 mt-1">Page not found</h1>
        <p className="text-sm text-slate-500 mt-2 max-w-sm mx-auto">
          The page you're looking for doesn't exist or you may not have access to it.
        </p>
        <Link
          to="/"
          className="inline-flex items-center mt-6 px-4 py-2 bg-ink-900 text-white text-sm font-medium rounded-md hover:bg-ink-800 transition-colors"
        >
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default Error;
